var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return (_vm.bannerImage)?_c('HeroBanner',{attrs:{"title":_vm.title,"banner-image":_vm.bannerImage,"banner-image-mobile":_vm.bannerImageMobile}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }